"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContext = exports.ContextSource = exports.getInputs = void 0;
const core = __importStar(require("@actions/core"));
const util_1 = require("@docker/actions-toolkit/lib/util");
const git_1 = require("@docker/actions-toolkit/lib/git");
const github_1 = require("@docker/actions-toolkit/lib/github");
function getInputs() {
    return {
        context: (core.getInput('context') || ContextSource.workflow),
        images: util_1.Util.getInputList('images', { ignoreComma: true, comment: '#' }),
        tags: util_1.Util.getInputList('tags', { ignoreComma: true, comment: '#' }),
        flavor: util_1.Util.getInputList('flavor', { ignoreComma: true, comment: '#' }),
        labels: util_1.Util.getInputList('labels', { ignoreComma: true, comment: '#' }),
        annotations: util_1.Util.getInputList('annotations', { ignoreComma: true, comment: '#' }),
        sepTags: core.getInput('sep-tags', { trimWhitespace: false }) || `\n`,
        sepLabels: core.getInput('sep-labels', { trimWhitespace: false }) || `\n`,
        sepAnnotations: core.getInput('sep-annotations', { trimWhitespace: false }) || `\n`,
        bakeTarget: core.getInput('bake-target') || `docker-metadata-action`,
        githubToken: core.getInput('github-token')
    };
}
exports.getInputs = getInputs;
var ContextSource;
(function (ContextSource) {
    ContextSource["workflow"] = "workflow";
    ContextSource["git"] = "git";
})(ContextSource || (exports.ContextSource = ContextSource = {}));
function getContext(source, toolkit) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (source) {
            case ContextSource.workflow:
                return yield getContextFromWorkflow(toolkit);
            case ContextSource.git:
                return yield getContextFromGit();
            default:
                throw new Error(`Invalid context source: ${source}`);
        }
    });
}
exports.getContext = getContext;
function getContextFromWorkflow(toolkit) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const context = github_1.GitHub.context;
        // Needs to override Git reference with pr ref instead of upstream branch ref
        // for pull_request_target event
        // https://docs.github.com/en/actions/using-workflows/events-that-trigger-workflows#pull_request_target
        if (/pull_request_target/.test(context.eventName)) {
            context.ref = `refs/pull/${context.payload.number}/merge`;
        }
        // DOCKER_METADATA_PR_HEAD_SHA env var can be used to set associated head
        // SHA instead of commit SHA that triggered the workflow on pull request
        // event.
        if (/true/i.test(process.env.DOCKER_METADATA_PR_HEAD_SHA || '')) {
            if ((/pull_request/.test(context.eventName) || /pull_request_target/.test(context.eventName)) && ((_c = (_b = (_a = context.payload) === null || _a === void 0 ? void 0 : _a.pull_request) === null || _b === void 0 ? void 0 : _b.head) === null || _c === void 0 ? void 0 : _c.sha) != undefined) {
                context.sha = context.payload.pull_request.head.sha;
            }
        }
        return Object.assign({ commitDate: yield getCommitDateFromWorkflow(context.sha, toolkit) }, context);
    });
}
function getContextFromGit() {
    return __awaiter(this, void 0, void 0, function* () {
        const ctx = yield git_1.Git.context();
        return Object.assign({ commitDate: yield git_1.Git.commitDate(ctx.sha) }, ctx);
    });
}
function getCommitDateFromWorkflow(sha, toolkit) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const event = github_1.GitHub.context.payload;
        if (event.commits) {
            const commitDate = (_a = event.commits.find(x => x.id === sha)) === null || _a === void 0 ? void 0 : _a.timestamp;
            if (commitDate) {
                return new Date(commitDate);
            }
        }
        if (event.head_commit) {
            if (event.head_commit.id === sha) {
                return new Date(event.head_commit.timestamp);
            }
        }
        // fallback to github api for commit date
        try {
            const commit = yield toolkit.github.octokit.rest.repos.getCommit({
                owner: github_1.GitHub.context.repo.owner,
                repo: github_1.GitHub.context.repo.repo,
                ref: sha
            });
            if ((_b = commit.data.commit.committer) === null || _b === void 0 ? void 0 : _b.date) {
                return new Date(commit.data.commit.committer.date);
            }
            throw new Error('Committer date not found');
        }
        catch (error) {
            core.debug(`Failed to get commit date from GitHub API: ${error.message}`);
            return new Date();
        }
    });
}
